import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Dot } from 'recharts';
import { useDemandCurve } from '../../hooks/useCalculations';
import { PRICE_POINTS } from '../../data/conjointData';
import { formatPrice } from '../../lib/formatters';
import { GRID_PROPS, X_AXIS_PROPS, Y_AXIS_PROPS, TOOLTIP_STYLE, CHART_COLORS } from '../../styles/chart-theme';
import { InfoButton } from '../common/Tooltip';
import { useIsMobile } from '../../hooks/useIsMobile';

export function DemandCurveChart() {
  const isMobile = useIsMobile();
  const curve = useDemandCurve(80);
  const data = curve.map(pt => ({ price: pt.price, rate: pt.rate * 100, isTested: PRICE_POINTS.some(pp => Math.abs(pp.price - pt.price) < 15) }));

  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-1">
        <h3 className="text-heading font-semibold text-secondary uppercase tracking-wider">Demand Curve (Interpolated)</h3>
        <InfoButton helpKey="demandCurve" size={13} />
      </div>
      <p className="text-sm text-muted mb-4">Linear interpolation between tested price points. Dots mark actual study data.</p>
      <ResponsiveContainer width="100%" height={isMobile ? 220 : 320}>
        <AreaChart data={data} margin={{ top: 10, right: 20, left: 10, bottom: 10 }}>
          <defs>
            <linearGradient id="demandGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={CHART_COLORS.teal} stopOpacity={0.3} />
              <stop offset="100%" stopColor={CHART_COLORS.teal} stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid {...GRID_PROPS} />
          <XAxis dataKey="price" {...X_AXIS_PROPS} tickFormatter={v => formatPrice(v)} />
          <YAxis {...Y_AXIS_PROPS} tickFormatter={v => `${v}%`} domain={[0, 'auto']} />
          <Tooltip {...TOOLTIP_STYLE} formatter={(value: number) => [`${value.toFixed(1)}%`, 'Choice Rate']} labelFormatter={v => formatPrice(Number(v))} />
          <Area type="monotone" dataKey="rate" stroke={CHART_COLORS.teal} strokeWidth={2} fill="url(#demandGradient)"
            dot={(props: any) => {
              if (!props.payload.isTested) return <g key={props.key} />;
              return <Dot key={props.key} cx={props.cx} cy={props.cy} r={5} fill={CHART_COLORS.teal} stroke="var(--color-dot-stroke)" strokeWidth={2} />;
            }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
